import { MaybeRefOrGetter } from '@vueuse/core';

import type { Requirement } from '../../schemas/requirement';

type UseRequirementReturnType<T extends Requirement> = {
  requirement: ComputedRef<T['step']['requirements'][number] | undefined>;
  requirements: ComputedRef<T['step']['requirements']>;
  evidence: ComputedRef<T['step']['evidences'][number] | undefined>;
  artefact: ComputedRef<T['step']['evidences'][number]['artefact'] | undefined>;
  isFilled: ComputedRef<boolean>;
  remainingAttempts: ComputedRef<number | null | undefined>
};

export function useRequirement<T extends Requirement>(_step: MaybeRefOrGetter<T | undefined>): UseRequirementReturnType<T> {
  const step = toRef(() => toValue(_step)?.step);
  const requirement = computed(() => step.value?.requirements[0]);
  const requirements = computed(() => step.value?.requirements ?? []);
  const evidence = computed(() => step.value?.evidences[0]);
  const artefact = computed(() => evidence.value?.artefact);
  const isFilled = computed(() => requirements.value.length > 0 && requirements.value.every(({ filled }) => filled));
  const remainingAttempts = computed(() => step.value?.remainingAttempts);

  return {
    requirement,
    requirements,
    evidence,
    artefact,
    isFilled,
    remainingAttempts,
  };
}
